module.exports = __webpack_public_path__ + "media/media/service/resource_savings-2c51510b8efa0460465f5195f5e91e42.png";